var ConfirmationType;
(function (ConfirmationType) {
    ConfirmationType["Delete"] = "DELETE";
    ConfirmationType["Exit"] = "EXIT";
})(ConfirmationType || (ConfirmationType = {}));
export var ErrorCode;
(function (ErrorCode) {
    ErrorCode["FileInvalidType"] = "file-invalid-type";
    ErrorCode["FileTooLarge"] = "file-too-large";
})(ErrorCode || (ErrorCode = {}));
export default ConfirmationType;
//# sourceMappingURL=typings.js.map